import React, { Component } from 'react';

const INITIAL_STATE = {
};

// Helper function to create a squircle path
const createSquirclePath = (width, height, radius) => {
  const w = width / 2;
  const h = height / 2;
  const r = radius;
  
  // Simplified squircle using SVG path with rounded corners
  return `M ${w - r}, 0 
          L ${w + r}, 0 
          Q ${w + w}, 0 ${w + w}, ${h - r}
          L ${w + w}, ${h + r}
          Q ${w + w}, ${h + h} ${w + r}, ${h + h}
          L ${w - r}, ${h + h}
          Q 0, ${h + h} 0, ${h + r}
          L 0, ${h - r}
          Q 0, 0 ${w - r}, 0
          Z`;
};

class SquircleIcon extends Component {

  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE };
  }

  render = () => {
    var ellipseSize = (this.props.size === 'medium') ? 42 : 18;
    var fontSize = (this.props.size === 'medium') ? "25" : "10"
    var fontClasses = "material-icons-outlined md-light md-" + fontSize;

    // Simple rounded rectangle - close enough to squircle for most use cases
    const containerStyle = {
      width: ellipseSize,
      height: ellipseSize,
      backgroundColor: "#" + this.props.colour,
      borderRadius: '25%', // Creates a nice rounded rectangle
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    };

    // Style for the icon to ensure it's centered
    const iconStyle = {
      color: "white",
      lineHeight: '1', // Ensures icon is vertically centered
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    };

    return (
      <div style={containerStyle}>
        <div className={fontClasses} style={iconStyle}>{this.props.icon}</div>
      </div> 
    );
  }
}

export default SquircleIcon;